(() => {
  if (window.mavoliraCinemaMounted) return;
  window.mavoliraCinemaMounted = true;
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const cards = [...root.querySelectorAll('[data-cinema-card]')];
    if (!cards.length) return;
    const controller = new AbortController();
    const { signal } = controller;
    const stage = root.querySelector('[data-cinema-stage]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let active = Math.min(2, cards.length - 1), width = 0, step = 0, visible = false;
    let paused = false, hovering = false, focused = false, timer, start, dragged = false;
    const offset = i => ((i - active + cards.length + Math.floor(cards.length / 2)) % cards.length) - Math.floor(cards.length / 2);
    function render(announce = false) {
      cards.forEach((card, i) => {
        const d = offset(i);
        const shown = Math.abs(d) <= (width < 600 ? 1 : 2);
        card.style.setProperty('--cinema-x', `${d * step}px`);
        card.style.setProperty('--cinema-angle', `${-d * 5}deg`);
        card.style.setProperty('--cinema-scale', `${1 - Math.min(Math.abs(d), 3) * .045}`);
        card.style.setProperty('--cinema-y', `${Math.abs(d) * 8}px`);
        card.style.zIndex = String(cards.length - Math.abs(d));
        card.style.setProperty('--cinema-opacity', shown ? '1' : '0');
        card.style.pointerEvents = shown ? '' : 'none';
        card.inert = !shown;
        card.setAttribute('aria-hidden', String(!shown));
        card.dataset.active = String(d === 0);
      });
      if (announce) root.querySelector('[data-cinema-status]').textContent = cards[active].textContent.trim();
    }
    function schedule() {
      clearTimeout(timer);
      if (root.dataset.autoplay !== 'true' || paused || hovering || focused || !visible || document.hidden || reduced.matches || cards.length < 2) return;
      timer = setTimeout(() => move(1), Number(root.dataset.speed) || 5000);
    }
    function move(direction, announce = false) {
      active = (active + direction + cards.length) % cards.length;
      render(announce);
      schedule();
    }
    function resize() {
      width = stage.clientWidth;
      const mobile = matchMedia('(max-width: 749px)').matches;
      const cardWidth = mobile ? width * .9 : width < 600 ? width * .68 : width < 1000 ? width * .3 : width * .18;
      step = mobile ? cardWidth + 12 : width < 600 ? cardWidth * 1.08 : width < 1000 ? width * .335 : width * .2;
      const height = cardWidth * 4 / 3 + 56;
      root.style.setProperty('--cinema-card-width', `${cardWidth}px`);
      root.style.setProperty('--cinema-card-height', `${height}px`);
      root.style.setProperty('--cinema-stage-height', `${height + (mobile ? 12 : 48)}px`);
      render();
    }
    root.querySelector('[data-cinema-prev]').addEventListener('click', () => move(-1, true), { signal });
    root.querySelector('[data-cinema-next]').addEventListener('click', () => move(1, true), { signal });
    root.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1, true);
    }, { signal });
    root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; schedule(); } }, { signal });
    root.addEventListener('pointerleave', () => { hovering = false; schedule(); }, { signal });
    root.addEventListener('focusin', () => { focused = true; schedule(); }, { signal });
    root.addEventListener('focusout', event => { focused = root.contains(event.relatedTarget); schedule(); }, { signal });
    stage.addEventListener('dragstart', event => event.preventDefault(), { signal });
    stage.addEventListener('pointerdown', event => { if (event.button !== 0) return; start = { x: event.clientX, y: event.clientY }; dragged = false; }, { signal });
    window.addEventListener('pointerup', event => {
      if (!start) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dragged = true; move(dx < 0 ? 1 : -1, true); }
    }, { signal });
    stage.addEventListener('pointercancel', () => { start = null; }, { signal });
    stage.addEventListener('click', event => { if (dragged) { event.preventDefault(); dragged = false; } }, { capture: true, signal });
    document.addEventListener('visibilitychange', schedule, { signal });
    reduced.addEventListener('change', schedule, { signal });
    root.addEventListener('shopify:block:select', event => {
      const index = cards.findIndex(card => card === event.target || card.contains(event.target));
      if (index >= 0) { active = index; paused = true; render(); schedule(); }
    }, { signal });
    const resizeObserver = new ResizeObserver(resize);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .15 });
    resize();
    root.classList.add('is-ready');
    root.querySelector('[data-cinema-controls]').hidden = cards.length < 2;
    resizeObserver.observe(root);
    observer.observe(root);
    instances.set(root, () => { controller.abort(); clearTimeout(timer); resizeObserver.disconnect(); observer.disconnect(); });
  }
  function start() { document.querySelectorAll('[data-ms-cinema]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
})();
